<template>
  <div class="h-full p-20px">
    <div class="h-full  flex flex-column">
      <vxe-toolbar class="px-16px">
        <template #buttons>
          <vxe-button :loading="dataLoading" @click="backUp" status="primary" icon="fa fa-database" content="开始备份"/>
          <vxe-button :loading="dataLoading" @click="fileInput.click();" status="success" icon="fa fa-upload" content="上传本地备份"/>
          <input accept="application/zip" type="file" @change="uploadBackUp" ref="fileInput" style="position: absolute;z-index: -1"/>
        </template>
      </vxe-toolbar>
      <div class="flex-1">
        <vxe-table height="auto" ref="xTable" :loading="dataLoading" show-overflow stripe :data="dataList">
          <vxe-column title="备份名称" field="title" width="400"/>
          <vxe-column title="备份日期" field="bakTime"/>
          <vxe-column title="文件大小" field="size"/>
          <vxe-column title="操作人" field="userName"/>
          <vxe-column title="操作" :width="150" align="center" width="200">
            <template #default="{row}">
              <div class="actions">
                <span @click="recover(row)">恢复</span>
                <span @click="remove(row)">删除</span>
                <a :href="'/api/backup/download/'+row.id" :download="'（数据包加密不能查看，仅供数据恢复使用）'+row.title">下载</a>
              </div>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
export default {
  name: "BakUp"
}
</script>

<script setup>
import {confirm, loading} from "heyui.ext";
import {ref, h} from "vue";
import setting from "@/api/setting";
import RecoverForm from "@/views/setting/RecoverForm";
import {layer} from "@layui/layer-vue";

const dataLoading = ref(false)
const dataList = ref([])
const fileInput = ref(null)

const loadList = () => {
  dataLoading.value = true;
  setting.backup.list().then(({data}) => {
    dataList.value = data;
  }).finally(() => dataLoading.value = false)
}
loadList();

const backUp = () => {
  loading("备份中...")
  setting.backup.backup().then(() => {
    loadList();
  }).finally(() => loading.close())
}

const remove = (row) => {
  confirm({
    content: "确认删除此备份?",
    async: true,
    onConfirm(resolve) {
      loading("删除中...")
      setting.backup.delete(row.id).then(() => {
        loadList();
      }).finally(() => {
        loading.close();
        resolve(true);
      })
    }
  })
}

const recover = (entity) => {
  let layerId = layer.open({
    title: "恢复数据",
    shadeClose: false,
    closeBtn: false,
    zIndex: 1000,
    area: ['550px', 'auto'],
    content: h(RecoverForm, {
      entity,
      onClose: () => {
        layer.close(layerId);
      }
    })
  });
}

const uploadBackUp = () => {
  if (fileInput.value.files.length) {
    loading("上传中...")
    const formData = new FormData();
    formData.append("file", fileInput.value.files[0]);
    setting.backup.upload(formData).then(() => {
      loadList();
    }).finally(() => loading.close())
  }

}
</script>
